import { render, staticRenderFns } from "./Award_area.vue?vue&type=template&id=6f99a842&scoped=true&"
import script from "./Award_area.vue?vue&type=script&lang=js&"
export * from "./Award_area.vue?vue&type=script&lang=js&"
import style0 from "./Award_area.vue?vue&type=style&index=0&id=6f99a842&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f99a842",
  null
  
)

export default component.exports